import { DocumentTypeMetadata, IDocumentType } from "../models";
import { useEffect, useState } from "react";

import { FieldFilterType } from "../../../../base/types";
import { IFilterGroup } from "../../../../data";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";

// TODO:: status fields should be optimized
export const useGetDocumentType = (documentTypeId?: string) => {
    const [readRecords] = useLazyReadMultipleQuery();
    const { user, siteId: portalId } = useAuth()
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [error, setError] = useState<string>()
    const [data, setData] = useState<IDocumentType>()

    const getDocumentType = (documentTypeId: string) => {
        if (!user)
            return Promise.reject();

        const { userId } = user;
        if (!portalId)
            return Promise.reject();

        setIsSuccess(false)
        setIsError(false)
        setError(undefined)
        setIsLoading(true)

        const { tableId, fields } = DocumentTypeMetadata
        const fieldList: string[] = [
            fields.id,
            fields.categoryId,
            fields.description
        ]
        const filters: IFilterGroup[] = [{
            group: 0,
            filters: [
                { field: fields.id, type: FieldFilterType.Const, value: documentTypeId },
            ]
        }]

        return readRecords({ userId, portalId, tableId: tableId, fieldList, recordLimit: 0, filters })
            .unwrap()
            .then(data => {
                const records = data?.records || [];
                if (records.length > 0) {
                    const record = records[0];
                    const documentType: IDocumentType = {
                        id: record[fields.id],
                        documentCategoryId: record[fields.categoryId],
                        description: record[fields.description],
                    }
                    setData(documentType);
                    setIsSuccess(true)

                    return documentType;
                } else {
                    setData(undefined)
                    setIsError(true)
                    setError(`Document Type Id: ${documentTypeId} not found.`)
                    console.error(`Document Type Id: ${documentTypeId} not found.`)
                    return Promise.reject()
                }
            })
            .catch(err => {
                setIsError(true)
                setError(err.data?.error?.message || 'Failed to get data')
                return Promise.reject()
            })
            .finally(() => setIsLoading(false))
    }

    useEffect(() => {
        if (!documentTypeId)
            return;

        getDocumentType(documentTypeId)
        // eslint-disable-next-line
    }, [documentTypeId])

    return { data, isLoading, isSuccess, isError, error, getDocumentType }
}
